import React, { useState, useRef } from "react";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import { MdInfoOutline as Info } from "react-icons/md";

import { useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import "./TipCommun1.css";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

function Icon() {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  return (
    <>
      <button
        type="button"
        onClick={() => setShow(!show)}
        style={{
          backgroundColor: "rgba(52, 52, 52, 0.0)",
          borderColor: "rgba(52, 52, 52, 0.0)",
        }}
        ref={target}>
        <Info style={{ color: "black" }} />
      </button>
      <Overlay target={target.current} show={show} placement="bottom" flip>
        {(props) => (
          <Popover id="popover-basic" {...props}>
            <Popover.Title
              as="h3"
              style={{
                textAlign: "center",
                position: "relative",
                paddingRight: 28,
              }}
            >
              Paiements sécurisés
              <button
                type="button"
                aria-label="Fermer"
                onClick={() => setShow(false)}
                style={{
                  position: "absolute",
                  top: 2,
                  right: 6,
                  border: "none",
                  background: "transparent",
                  fontSize: 18,
                  lineHeight: 1,
                  cursor: "pointer",
                  color: "#333",
                }}
              >
                ×
              </button>
            </Popover.Title>
            <Popover.Content style={{ textAlign: "left" }}>
              Tous les paiements effectués sur Tipourboire sont cryptés. <br />
              Ils sont gérés par Stripe, notre partenaire de confiance.
              <br /> Leur technologie sécurisée nous permet d'être assurés que
              le montant reglé pour une transaction est bien envoyé et reçu par
              le(s) serveur(s).
            </Popover.Content>
          </Popover>
        )}
      </Overlay>
    </>
  );
}

function CommunPaymentForm() {
  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();
  const [amount, setAmount] = useState("");
  const [processing, setProcessing] = useState(false);
  // Message d'erreur affiché en bandeau dans la page (remplace l'alert natif
  // qui prenait tout l'écran et obligeait à rescanner le QR). TPB-62
  const [errorMsg, setErrorMsg] = useState("");

  // Traduit en français les erreurs de carte Stripe courantes (cryptogramme,
  // numéro, expiration...) pour que l'utilisateur sache quoi corriger. TPB-62
  const messageErreurPaiement = (error) => {
    // Message volontairement générique (ne pointe pas un champ précis). Seule la
    // carte refusée est distinguée, ce n'est pas une erreur de saisie. TPB-62
    if (error && error.code === "card_declined") {
      return "Votre carte a été refusée, veuillez réessayer avec une autre carte.";
    }
    return "Les informations de votre carte de paiement sont erronées, veuillez vérifier le numéro, la date d'expiration et le cryptogramme, puis réessayer.";
  };

  const handlePay = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    if (!amount || Number(amount) < 1) {
      setErrorMsg("Le pourboire minimum est de 1 euro.");
      return;
    }
    setErrorMsg("");
    setProcessing(true);
    try {
      const res = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/client/create-payment-intent",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount: Number(amount),
            type: "commun",
            etablissementId: localStorage.getItem("@idRestaurant"),
            clientEmail: localStorage.getItem("@dataMail") || "",
            restaurantName: localStorage.getItem("restaurantName") || "",
          }),
        }
      );
      const data = await res.json();
      if (!data.clientSecret) {
        setErrorMsg(
          data.message || "Une erreur s'est produite, veuillez réessayer."
        );
        setProcessing(false);
        return;
      }
      const result = await stripe.confirmCardPayment(data.clientSecret, {
        payment_method: { card: elements.getElement(CardElement) },
      });
      if (result.error) {
        setErrorMsg(messageErreurPaiement(result.error));
        setProcessing(false);
        return;
      }
      if (
        result.paymentIntent &&
        result.paymentIntent.status === "succeeded"
      ) {
        window.confirm(
          "Merci pour votre pourboire. À bientôt dans nos établissements partenaires."
        );
        history.push("/CommentairesReferent" + window.location.search);
      } else {
        setErrorMsg(
          "Le paiement n'a pas pu aboutir, veuillez réessayer dans quelques instants."
        );
        setProcessing(false);
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("Une erreur s'est produite, veuillez réessayer.");
      setProcessing(false);
    }
  };

  return (
    <Container className="mainBlocCommun">
      <Row>
        <Col className="blocCommun" xs={12} s={12} md={12}>
          <p className="titleCommun">Paiement du pourboire</p>
          <h5 className="tipsMin">Le tips doit être de 1 euro minimum !</h5>
          {errorMsg && (
            <div
              role="alert"
              style={{
                position: "relative",
                color: "#842029",
                background: "#f8d7da",
                border: "1px solid #dc3545",
                borderRadius: 6,
                padding: "10px 34px 10px 12px",
                marginTop: 10,
                fontSize: 14,
                textAlign: "left",
              }}
            >
              {errorMsg}
              <button
                type="button"
                aria-label="Fermer"
                onClick={() => setErrorMsg("")}
                style={{
                  position: "absolute",
                  top: 4,
                  right: 8,
                  border: "none",
                  background: "transparent",
                  color: "#842029",
                  fontSize: 20,
                  lineHeight: 1,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
          )}
        </Col>
        <Col className="formCommun" xs={12} s={12} md={12}>
          <Form className="formCommun" onSubmit={handlePay}>
            <Form.Group className="formCommunGrp" controlId="formGroupAmount">
              <Form.Control
                name="amount"
                type="number"
                placeholder="Montant du Don Général"
                value={amount}
                onChange={(e) => {
                  setAmount(e.target.value);
                  setErrorMsg("");
                }}
                className="inputPaymentTips"
              />
              <div
                className="inputPaymentTips"
                style={{
                  padding: 12,
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  background: "#fff",
                }}>
                <CardElement
                  options={{ hidePostalCode: true }}
                  onChange={() => setErrorMsg("")}
                />
              </div>
            </Form.Group>
            <Col className="ButtonCol" xs={12} s={12} md={12}>
              <Button
                className="communButtonVal"
                type="submit"
                disabled={!stripe || processing}>
                {processing ? "Paiement en cours..." : "Payer"}
              </Button>
              <Icon />
            </Col>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default function TipCommun1() {
  return (
    <Elements stripe={stripePromise}>
      <CommunPaymentForm />
    </Elements>
  );
}
